import { BASE_URL } from '../config';
import {token, clearLocalStorage} from '../libs/localStorage';
require('es6-promise').polyfill();
require('isomorphic-fetch');

const callApi = (method, endpoint, body) => {
  const fullUrl = `${BASE_URL}/${endpoint}`;

  const authToken = token.getEncoded();
  const commonOpts = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
  };

  const opts = body ?
    Object.assign(commonOpts, { body: JSON.stringify(body) }) :
    commonOpts;

  return fetch(fullUrl, opts)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        const { status } = response;
        const error = {
          ...json,
          status,
        };
        if (status === 401) {
          clearLocalStorage();
          window.location.reload();
        }
        return Promise.reject(error);
      }

      return json;
    });
    // .then(
      // response => (response),
      // error => ({ error: {
        // status: error.status,
        // message: error.message || 'Something bad happened',
      // } })
    // );
};

export const get = (endpoint) => callApi('GET', endpoint);
export const post = (endpoint, body) => callApi('POST', endpoint, body);
export const put = (endpoint, body) => callApi('PUT', endpoint, body);
export const del = (endpoint, body) => callApi('DELETE', endpoint, body);



// WEBPACK FOOTER //
// ./src/actions/apiMethods.js